var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.574,
    height: 13.568,
    viewBox: "0 0 13.574 13.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.004 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.018,96.647H1.559A1.556,1.556,0,0,1,0,95.093v-8.2A1.556,1.556,0,0,1,1.559,85.34H3.538a.424.424,0,0,1,0,.848H1.559a.708.708,0,0,0-.707.707v8.2a.708.708,0,0,0,.707.707h10.46a.708.708,0,0,0,.707-.707V90.287a.424.424,0,0,1,.848,0v4.806a1.556,1.556,0,0,1-1.555,1.555Zm0,0",
    transform: "translate(-0.004 -83.078)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.427,9.039a.373.373,0,0,1-.093-.011.418.418,0,0,1-.33-.4V7.775a5.519,5.519,0,0,1,5.512-5.512h.141V.425a.424.424,0,0,1,.729-.294l3.675,3.816a.423.423,0,0,1,0,.588l-3.675,3.816a.424.424,0,0,1-.729-.294V6.22h-.672a4.638,4.638,0,0,0-4.171,2.58A.437.437,0,0,1,128.427,9.039Zm5.089-5.929a4.672,4.672,0,0,0-4.629,4.082,5.482,5.482,0,0,1,4.1-1.82h1.1a.424.424,0,0,1,.424.424v1.21l2.662-2.765-2.662-2.765v1.21a.424.424,0,0,1-.424.424Zm0,0",
    transform: "translate(-124.611)",
    fill: "#26B963"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.84c1081fd7d8bfee2555f7e7e05c816b.svg";
export { ForwardRef as ReactComponent };